import {
  DELETE_PLAN_LOADING,
  DELETE_PLAN_SUCCESS,
  DELETE_PLAN_FAILED,
  DELETE_PLAN_RESET,
} from "../types";
import { Plan } from "../../models/Plan";

interface DeletePlanState {
  loading: boolean;
  error: string | null;
  deletedPlan: Plan | null;
  success: boolean;
}

const initialState: DeletePlanState = {
  loading: false,
  error: null,
  deletedPlan: null,
  success: false,
};

export const deletePlanReducer = (
  state = initialState,
  action: any
): DeletePlanState => {
  switch (action.type) {
    case DELETE_PLAN_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case DELETE_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        deletedPlan: action.payload,
        success: true,
      };
    case DELETE_PLAN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to delete plan",
        deletedPlan: null,
        success: false,
      };
    case DELETE_PLAN_RESET:
      return initialState;
    default:
      return state;
  }
};
